// src/components/VirusTotalCard.tsx
import React from 'react';
import { Shield, AlertCircle, ExternalLink } from 'lucide-react';

interface VirusTotalCardProps {
  vtData: {
    found?: boolean;
    malicious?: number;
    total_engines?: number;
    detection_rate?: number;
    url?: string;
    error?: string;
  };
}

const VirusTotalCard: React.FC<VirusTotalCardProps> = ({ vtData }) => {
  if (vtData.error) {
    return (
      <div className="info-card">
        <h3 className="card-title">VirusTotal</h3>
        <div className="vt-error">
          <AlertCircle size={48} className="vt-icon" />
          <p>{vtData.error}</p>
        </div>
      </div>
    );
  }

  if (!vtData.found) {
    return (
      <div className="info-card">
        <h3 className="card-title">VirusTotal</h3>
        <div className="vt-not-found">
          <Shield size={48} className="vt-icon" />
          <p>Not in VT database</p>
          <span className="vt-note">File may be new or unseen</span>
        </div>
      </div>
    );
  }

  const detectionRate = vtData.detection_rate || 0;
  const angle = detectionRate * 360;
  
  return (
    <div className="info-card">
      <h3 className="card-title">VirusTotal</h3>
      <div className="vt-container">
        <div className="vt-rate">
          <div className="vt-circle">
            <svg width="120" height="120" viewBox="0 0 120 120">
              <circle cx="60" cy="60" r="54" fill="none" stroke="#2a2a3a" strokeWidth="12"/>
              <circle cx="60" cy="60" r="54" fill="none" stroke={detectionRate > 0.5 ? '#ef4444' : '#22c55e'} strokeWidth="12" strokeDasharray={`${angle} ${360 - angle}`} strokeDashoffset="0" transform="rotate(-90 60 60)" strokeLinecap="round"/>
              <text x="60" y="65" textAnchor="middle" fill="#e2e2e8" fontSize="20" fontWeight="bold">{detectionRate > 0 ? `${(detectionRate * 100).toFixed(0)}%` : '0%'}</text>
            </svg>
          </div>
          <div className="vt-stats">
            <div className="vt-stat">
              <span className="vt-stat-label">Detection Rate</span>
              <span className="vt-stat-value">{(detectionRate * 100).toFixed(1)}%</span>
            </div>
            <div className="vt-stat">
              <span className="vt-stat-label">Malicious Reports</span>
              <span className="vt-stat-value">{vtData.malicious} / {vtData.total_engines}</span>
            </div>
          </div>
        </div>
        {vtData.url && (
          <a href={vtData.url} target="_blank" rel="noopener noreferrer" className="vt-button">
            View on VirusTotal <ExternalLink size={14} />
          </a>
        )}
      </div>
    </div>
  );
};

export default VirusTotalCard;